import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { currencyFormatter } from "shared";

import { useFetchWalletBalanceQuery } from "../../services/api/contactsApi/contact";

import { CallPricingLink } from "./CallPricing";

/** Everyone sees the balance, only the subscription owner gets the link to manage it */
export function WalletBalance() {
  const { organisationId } = useParams<{ organisationId: string }>();
  const { data } = useFetchWalletBalanceQuery({ organisationId }, { skip: !organisationId });

  if (!data) return null;

  return (
    <div className={ `mb-4 flex items-center justify-between rounded-lg border border-gray-200 bg-white px-5 py-3 text-sm` }>
      <div>
        <span className={ `text-gray-500` }>{ `Prepaid credit: ` }</span>
        <span className={ `font-semibold text-paidniceGreen-800` }>
          { currencyFormatter(data.currency)(data.balanceCents / 100) }
        </span>
      </div>
      <div className={ `flex items-center gap-4` }>
        <CallPricingLink currency={ data.currency } />
        { data.canManage ? (
          <Link
            to={ `/billing/subscriptions/${data.subscriptionId}#wallet` }
            className={ `cursor-pointer font-semibold text-paidniceGreen-600 hover:text-paidniceGreen-700` }
          >
            { `Manage credit →` }
          </Link>
        ) : null }
      </div>
    </div>
  );
}
